// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  visibleUnitId: __t.string().primaryKey().name("visible_unit_id"),
  playerId: __t.string().name("player_id"),
  matchId: __t.string().name("match_id"),
  unitId: __t.string().name("unit_id"),
  armyIndex: __t.u32().name("army_index"),
  archetype: __t.string(),
  name: __t.string(),
  x: __t.f64(),
  y: __t.f64(),
  facing: __t.f64(),
  state: __t.string(),
  stance: __t.string(),
  marching: __t.bool(),
  strength: __t.f64(),
  maxStrength: __t.f64().name("max_strength"),
  troopsAlive: __t.u32().name("troops_alive"),
  troopsMax: __t.u32().name("troops_max"),
  isGeneral: __t.bool().name("is_general"),
  category: __t.string(),
  symbol: __t.string(),
  level: __t.u32(),
  isRanged: __t.bool().name("is_ranged"),
  suppressed: __t.bool(),
  followMode: __t.bool().name("follow_mode"),
  garrisonedIn: __t.option(__t.u32()).name("garrisoned_in"),
  ammo: __t.option(__t.u32()),
  maxAmmo: __t.option(__t.u32()).name("max_ammo"),
  fireRange: __t.option(__t.f64()).name("fire_range"),
  rangedStance: __t.option(__t.string()).name("ranged_stance"),
  fireAtWill: __t.option(__t.bool()).name("fire_at_will"),
  length: __t.f64(),
  width: __t.f64(),
  squadId: __t.option(__t.string()).name("squad_id"),
  squadSize: __t.u32().name("squad_size"),
  kills: __t.u32(),
  xpEarned: __t.u32().name("xp_earned"),
  formationFiles: __t.u32().name("formation_files"),
  formationRanks: __t.u32().name("formation_ranks"),
  columnParentId: __t.option(__t.string()).name("column_parent_id"),
  columnIndex: __t.u32().name("column_index"),
  columnPhase: __t.option(__t.string()).name("column_phase"),
  artilleryJson: __t.option(__t.string()).name("artillery_json"),
});
